export interface AdvisorChargeType {
  id: number;
  amount: number;
  percentage_value?: number;
  charge_type: number;
  source_account: number;
  destination_account: number;
  requested_for_policy: any;
  applied_to_policy: any;
}

export interface AdvisorChargesSummaryType {
  unallocated_initial: number;
  unallocated_initial_percentage: number;
  unallocated_ongoing: number;
  unallocated_ongoing_percentage: number;
}

export interface AppliedCharge {
  amount: string;
  id: number;
  policy_id: string | number | null;
  paid_directly: boolean;
}

export interface ChargeApplied {
  amount: string | number;
  charge_type: ChargeBase;
  id: number;
  percentage_value: number | null;
  applied_charges: AppliedCharge[];
}

type SourceType = {
  policy_id: string | null | number;
  amount: string;
  paid_directly: boolean;
};

export interface ChargeType {
  charge_type: ChargeBase;
  amount?: null | string;
  percentage_value?: null | string | number;
  regular_contributions?: boolean;
  applied_charges: SourceType[];
}

export type ChargeFromPolicy = {
  charge_allocation_amount: string;
  id: number | null;
  isChecked: boolean;
};

export enum ChargeBase {
  'INITIAL' = 1,
  'ONGOING' = 2,
  'INITIAL_REGULAR' = 3
}
